import script from "./DeviceModalSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceModalSimple.vue?vue&type=script&setup=true&lang=js"

import "./DeviceModalSimple.vue?vue&type=style&index=0&id=0a207144&lang=css"

const __exports__ = script;

export default __exports__